export enum AlertType {
  Error,
  Success,
}
